import { render, staticRenderFns } from "./NewsGroup.vue?vue&type=template&id=29d6f80e&"
import script from "./NewsGroup.vue?vue&type=script&lang=js&"
export * from "./NewsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports